/* eslint-disable no-underscore-dangle */
import React from 'react'

export type CommentaryOutlookCellProps = {
  cellProps: any
}

export type CommentaryOutlookItemProps = {
  title: string
  slug: string
}

export const commentaryFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { taggedReports } = data._original
  let result = false
  if (
    taggedReports.length &&
    taggedReports[0].title.toLowerCase().includes(filter)
  )
    result = true
  return result
}

export const CommentaryOutlookCell = (props: CommentaryOutlookCellProps) => {
  const { cellProps } = props
  const { taggedReports } = cellProps.original

  return (
    <>
      {taggedReports.length ? (
        <a className="bold--text" href={`/research/${taggedReports[0].slug}`}>
          {taggedReports[0].title}
        </a>
      ) : null}
    </>
  )
}
export default CommentaryOutlookCell
